<app-breadcrumb *ngIf="showFilter" [master]="'Należności'" [parentName]="'Zestawienia'" [name]="'Lista'"></app-breadcrumb>
<div class="receivables-statement-list-container">
  <form *ngIf="showFilter" (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="receivables-statement-list-filters">

  </form>


  <div  class="receivables-statement-list-buttons">
    <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()"> <mat-icon>download</mat-icon> Pobierz raport</button>
  </div>

  <table mat-table [dataSource]="rows" >


    <ng-container matColumnDef="data">
      <th mat-header-cell *matHeaderCellDef> Okres rozliczeniowy </th>
      <td mat-cell *matCellDef="let element">
        {{wednesdayWeekRange(element.createdAt)['start']| date: 'dd.MM.y'}}
        -
        {{wednesdayWeekRange(element.createdAt)['end']| date: 'dd.MM.y' }}
      </td>
    </ng-container>


    <ng-container matColumnDef="before">
      <th mat-header-cell *matHeaderCellDef>
        Saldo początkowe
      </th>
      <td mat-cell *matCellDef="let element">
        {{(element.receivablesBalanceBefore !== null ? element.receivablesBalanceBefore : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="payments">
      <th mat-header-cell *matHeaderCellDef>
        Suma wpłat
      </th>
      <td mat-cell *matCellDef="let element">
        {{(element.totalPayments !== null ? element.totalPayments : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="returns">
      <th mat-header-cell *matHeaderCellDef>
        Suma zwrotów
      </th>
      <td mat-cell *matCellDef="let element">
        {{(element.totalReturns !== null ? element.totalReturns : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="payouts">
      <th mat-header-cell *matHeaderCellDef>
        Suma obciążeń
      </th>
      <td mat-cell *matCellDef="let element">
        {{(element.totalPayouts !== null ? element.totalPayouts : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="after">
      <th mat-header-cell *matHeaderCellDef>
        Saldo końcowe
      </th>
      <td mat-cell *matCellDef="let element">
        {{(element.receivablesBalanceAfter !== null ? element.receivablesBalanceAfter : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" aria-label="" (click)="downloadReportHistory(element.createdAt)">
          <mat-icon>download</mat-icon>
        </button>
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
